import {
  PHOTO_SESSION_ISSUE_REPORT_VIEWED_ANALYTICS,
  PHOTO_SESSION_ISSUE_REPORT_CLICKED_ANALYTICS,
} from 'containers/IssueReport/types';

import { logWithDefaultProperties } from '../defaultLogger';
import { PAGE_NAMES } from '../constants';

export const handleIssueReportActions = (amplitudeInstance, action) => {
  switch (action.type) {
    case PHOTO_SESSION_ISSUE_REPORT_VIEWED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.ISSUE_REPORT,
        eventName: 'report_photo_session_viewed',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_ISSUE_REPORT_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.ISSUE_REPORT,
        eventName: 'report_photo_session_finish_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    default:
      break;
  }
};

export default handleIssueReportActions;
